import { withRouter } from "react-router-dom";
import { Button, Col, Row } from "reactstrap";

import { BsWallet2 } from "react-icons/bs";
import {
  FaExchangeAlt,
  FaMoneyBillWave
} from "react-icons/fa";
import { FaMoneyBillTransfer, FaRegMoneyBill1 } from "react-icons/fa6";
import { IoCashOutline } from "react-icons/io5";
import { encryptStorage } from "../../constants/EncryptStorage";
import { GetLanguageString } from "../helper/Components";

const QuickManageFund = ({ history }) => {
  const unitTypeName = encryptStorage.getItem("unitTypeName");
  return (
    <>
      <div className="wrapper wrapper-content wrapper-custom">
        <div className="ibox">
          <div className="ibox-content panel-body">
            <h3>{<GetLanguageString props="transactions_income" />}</h3>

            <Row>
              <Col xl="1" className="text-center">
                <Button
                  className="btn-danger dim btn-large-dim"
                  onClick={() =>
                    history.push({
                      pathname: `/funds/addInfaqCashInHand`,
                    })
                  }
                >
                  <FaRegMoneyBill1 size={50} />
                </Button>
                <h4>
                  {
                    <GetLanguageString props="transactions_infaq_to_cash_in_hand" />
                  }
                </h4>
              </Col>

              <Col xl="1" className="text-center">
                <Button
                  className="btn-info dim btn-large-dim"
                  onClick={() =>
                    history.push({
                      pathname: `/funds/addInfaqAmanatAccount`,
                    })
                  }
                >
                  <FaRegMoneyBill1 size={50} />
                </Button>
                <h4>
                  {
                    <GetLanguageString props="transactions_infaq_to_amanat_account" />
                  }
                </h4>
              </Col>

              <Col xl="1" className="text-center">
                <Button
                  className="btn-success dim btn-large-dim"
                  onClick={() =>
                    history.push({
                      pathname: `/funds/addBulkInfaq`,
                    })
                  }
                >
                  <FaMoneyBillWave size={50} />
                </Button>
                <h4>{<GetLanguageString props="funds_add_bulk_fund" />}</h4>
              </Col>

              <Col xl="1" className="text-center">
                <Button
                  className="btn-primary dim btn-large-dim"
                  onClick={() =>
                    history.push({
                      pathname: `/funds/manageIncome`,
                    })
                  }
                >
                  <BsWallet2 size={50} />
                </Button>
                <h4>{<GetLanguageString props="manage_income" />}</h4>
              </Col>
              <Col xl="1" className="text-center">
                <Button
                  className="btn-success dim btn-large-dim"
                  onClick={() =>
                    history.push({
                      pathname: `/funds/otherIncome`,
                    })
                  }
                >
                  <IoCashOutline size={50} />
                </Button>
                <h4>{<GetLanguageString props="funds_other_income" />}</h4>
              </Col>
              <Col xl="1" className="text-center">
                <Button
                  className="btn-warning dim btn-large-dim"
                  onClick={() =>
                    history.push({
                      pathname: `/funds/otherIncomeLoanFromMarkaz`,
                    })
                  }
                >
                  <IoCashOutline size={50} />
                </Button>
                <h4>
                  {
                    <GetLanguageString props="funds_other_income_loan_from_markaz" />
                  }
                </h4>
              </Col>
              {unitTypeName === "Halqa" && (
                <>
                  <Col xl="1" className="text-center">
                    <Button
                      className="btn-primary dim btn-large-dim"
                      onClick={() =>
                        history.push({
                          pathname: `/funds/OtherIncomeTarbiatiCourseReimbursment`,
                        })
                      }
                    >
                      <IoCashOutline size={50} />
                    </Button>
                    <h4>
                      {
                        <GetLanguageString props="funds_other_income_tarbiati_course_reimbursment" />
                      }
                    </h4>
                  </Col>
                  <Col xl="1" className="text-center">
                    <Button
                      className="btn-success dim btn-large-dim"
                      onClick={() =>
                        history.push({
                          pathname: `/funds/otherIncomeHelpFromMuqamiTanzeem`,
                        })
                      }
                    >
                      <IoCashOutline size={50} />
                    </Button>
                    <h4>
                      {
                        <GetLanguageString props="funds_other_income_assistance_from_muqami_tanzeem" />
                      }
                    </h4>
                  </Col>
                </>
              )}
            </Row>
          </div>
        </div>
      </div>

      <div
        style={{ marginTop: "-50px", padding: "5px" }}
        className="wrapper wrapper-content wrapper-custom"
      >
        <div className="ibox">
          <div className="ibox-content panel-body">
            <h3>{<GetLanguageString props="sidebar_funds_expenses" />}</h3>

            <Row>
              <Col xl="1" className="text-center">
                    <Button
                      className="btn-success dim btn-large-dim"
                      onClick={() =>
                        history.push({
                          pathname: `/funds/expenseFromCashInHand`,
                        })
                      }
                    >
                      <IoCashOutline size={50} />
                    </Button>
                    <h4>
                      {
                        <GetLanguageString props="finance_expense_cash_in_hand" />
                      }
                    </h4>
                  </Col>
              <Col xl="1" className="text-center">
                    <Button
                      className="btn-info dim btn-large-dim"
                      onClick={() =>
                        history.push({
                          pathname: `/funds/expenseFromAmanat`,
                        })
                      }
                    >
                      <IoCashOutline size={50} />
                    </Button>
                    <h4>
                      {
                        <GetLanguageString props="finance_expense_amanat_account" />
                      }
                    </h4>
                  </Col>
              <Col xl="1" className="text-center">
                <Button
                  className="btn-primary dim btn-large-dim"
                  onClick={() =>
                    history.push({
                      pathname: `/funds/manageExpense`,
                    })
                  }
                >
                  <BsWallet2 size={50} />
                </Button>
                <h4>{<GetLanguageString props="manage_expense" />}</h4>
              </Col>
            </Row>
          </div>
        </div>
      </div>

      <div
        style={{ marginTop: "-10px", padding: "5px" }}
        className="wrapper wrapper-content wrapper-custom"
      >
        <div className="ibox">
          <div className="ibox-content panel-body">
            <h3>{<GetLanguageString props="transfer" />}</h3>

            <Row>
              <Col xl="1" className="text-center">
                <Button
                  className="btn-warning dim btn-large-dim"
                  onClick={() =>
                    history.push({
                      pathname: `/funds/transferCashInHandToAmanat`,
                    })
                  }
                >
                  <FaMoneyBillTransfer />
                </Button>
                <h4>
                  {
                    <GetLanguageString props="transactions_cashinhand_to_amanat_account" />
                  }
                </h4>
              </Col>
              <Col xl="1" className="text-center">
                <Button
                  className="btn-danger dim btn-large-dim"
                  onClick={() =>
                    history.push({
                      pathname: `/funds/transferAmanatToCashInHand`,
                    })
                  }
                >
                  <FaMoneyBillTransfer />
                </Button>
                <h4>
                  {
                    <GetLanguageString props="transactions_amanat_to_cash_in_hand_account" />
                  }
                </h4>
              </Col>
              <Col xl="1" className="text-center">
                <Button
                  className="btn-info dim btn-large-dim"
                  onClick={() =>
                    history.push({
                      pathname: `/funds/manageTransfer`,
                    })
                  }
                >
                  <FaExchangeAlt />
                </Button>
                <h4>
                  {<GetLanguageString props="transactions_manage_transfer" />}
                </h4>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </>
  );
};

export default withRouter(QuickManageFund);
